import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DynamicForm } from '@app/model/dynamic-form';
import { AuthenticationService } from './authentication.service';
import { WorkOrder } from '@app/model/work-order.model';

@Injectable({
  providedIn: 'root'
})
export class WorkOrderService {

  constructor(private http: HttpClient,private authenticationService: AuthenticationService) { }
/*
  getFormData(form: OrdenDeTrabajoForm): FormData {
    const formaData = new FormData();
    let file: File;
    file = form.file;
    if (file != null) {
      formaData.append('files', form.file, form.file.name);
    }
    console.log("formulario a enviar "+JSON.stringify(form));
    const blob = new Blob([JSON.stringify(form)], {
      type: 'application/json'
      });
    formaData.append('requestDTO', blob);
    return formaData;
  }
  createOrdenDeTrabajo(form: OrdenDeTrabajoForm){
    console.log("createOrdenDeTrabajo iniciado ");
    const formaData = this.getFormData(form);
    return this.http.post('/notas-backend/api/v1.0/workorders', formaData);
  }
  updateOrdenDeTrabajo(form: OrdenDeTrabajoForm) {
    const formaData = this.getFormData(form);
    return this.http.put('/notas-backend/api/v1.0/workorders', formaData);
  }
  eliminarOrdenDeTrabajo(id: string) {
    return this.http.delete('/notas-backend/api/v1.0/workorders/'+id);
  }

  getOrdenDeTrabajo(id: string) {
    const formaData = new OrdenDeTrabajoForm();
    formaData.id = Number.parseInt(id);
    const search = new HttpParams();
    search.set('id', id);
    return this.http.get('/api/query/v1.0/workorders/cromo/' + id);
  }
  getProfiles() {
    return this.http
    .get<Tipo[]>(`/service-profile/api/v1.0/profiles`, {
      headers: new HttpHeaders().append('Accept', 'application/json')
    })
    .pipe(catchError(err => of([])));
  }

  getOrdenDeTrabajoTypes() {
    return this.http
      .get<OrdenDeTrabajoType[]>(`/notas-backend/api/v1.0/types`, {
        headers: new HttpHeaders().append('Accept', 'application/json')
      })
      .pipe(catchError(err => of([])));
  }

  getOrdenDeTrabajoEstados() {
    return this.http
      .get<OrdenDeTrabajoType[]>(`/notas-backend/api/v1.0/states`, {
        headers: new HttpHeaders().append('Accept', 'application/json')
      })
      .pipe(catchError(err => of([])));
  }
  getOrdenDeTrabajoPrioridades() {
    return this.http
      .get<OrdenDeTrabajoType[]>(`/notas-backend/api/v1.0/prioryties`, {
        headers: new HttpHeaders().append('Accept', 'application/json')
      })
      .pipe(catchError(err => of([])));
  }

  getUsuarioNombreCompleto(){
    return this.authenticationService.getFullName();
  }
  getQuestionsForm(){
    return this.http
      .get<WorkorderDynamicForm[]>(`/notas-backend/api/v1.0/workorders-form`, {
        headers: new HttpHeaders().append('Accept', 'application/json')
      })
      .pipe(catchError(err => of([])));
  }
  getQuestionsForm2(){
    return this.http
      .get<FormlyFieldConfig[]>(`/notas-backend/api/v1.0/workorders-form2`, {
        headers: new HttpHeaders().append('Accept', 'application/json')
      })
      .pipe(catchError(err => of([])));
  }
  */

 getFormData(model,file: File): FormData {
  const formaData = new FormData();
  if (file != null) {
    formaData.append('files', file, file.name);
  }
  console.log("formulario a enviar "+JSON.stringify(model));
  const blob = new Blob([JSON.stringify(model)], {
    type: 'application/json'
    });
  formaData.append('requestDTO', blob);
  return formaData;
}
getUsuarioNombreCompleto(){
  return this.authenticationService.getFullName();
}

/**Metodos contra el servicio*/
getOrdenDeTrabajo(id: string) {
  return this.http.get('/api/query/v1.0/workorders/cromo/' + id);
}
getWorkorders(){
  return this.http
    .get<WorkOrder[]>('/notas-backend/api/v1.0/workorders', {
      headers: new HttpHeaders().append('Accept', 'application/json')
    });
}
createOrdenDeTrabajo(model,file: File){
  console.log("createOrdenDeTrabajo iniciado ");
  const formaData = this.getFormData(model, file);
  return this.http.post('/notas-backend/api/v1.0/workorders', formaData);
}
updateOrdenDeTrabajo(model,file: File) {
  const formaData = this.getFormData(model, file);
  return this.http.put('/notas-backend/api/v1.0/workorders', formaData);
}
eliminarOrdenDeTrabajo(id: string) {
  return this.http.delete('/notas-backend/api/v1.0/workorders/'+id);
}
eliminarOrdenDeTrabajoComentario(id: string) {
  return this.http.delete('/notas-backend/api/v1.0/workorders/comment/'+id);
}
eliminarOrdenDeTrabajoArchivo(id: string) {
  return this.http.delete('/notas-backend/api/v1.0/workorders/file/'+id);
}
download(url){
  return this.http
    .get(`/notas-backend/api/v1.0/workorders/download?url=`+url, { responseType: 'blob'});
 }

getDownloadURL(url: string): string {
  return `/api/v1.0/workorders/preview?url=${url}`;
}

getWorkordersForms(ordenDeTrabajoId,accion){
  let url='/notas-backend/api/v1.0/workorders/forms';
  if(ordenDeTrabajoId!="" && ordenDeTrabajoId>0){
    url=url+"?id="+ordenDeTrabajoId+"&accion="+accion;
  }else if(accion != null){
    url=url+"?accion="+accion;
  }
  return this.http
    .get<DynamicForm[]>(url, {
      headers: new HttpHeaders().append('Accept', 'application/json')
    });
}
getWorkordersDataForms(){
  return this.http
    .get<any[]>(`/notas-backend/api/v1.0/workorders-data`, {
      headers: new HttpHeaders().append('Accept', 'application/json')
    });
 }
}
